import getCountryByNationalNumber from "./getCountryByNationalNumber.js";
function getCountryByCallingCode(callingCode, _ref) {
  var nationalPhoneNumber = _ref.nationalNumber, defaultCountry = _ref.defaultCountry, metadata = _ref.metadata, possibleCountries = metadata.getCountryCodesForCallingCode(callingCode);
  if (possibleCountries)
    return possibleCountries.length === 1 ? possibleCountries[0] : getCountryByNationalNumber(nationalPhoneNumber, {
      countries: possibleCountries,
      defaultCountry,
      metadata: metadata.metadata
    });
}
export {
  getCountryByCallingCode as default
};
//# sourceMappingURL=getCountryByCallingCode.js.map
